import React from 'react';
import Lightbox, { ILightBoxProps } from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

export const FullScreenCarousel: React.FC<ILightBoxProps> = (props) => (
  <Lightbox
    {...props}
  />
);
